module.exports = __webpack_public_path__ + "img/facility8.9160f3b3.png";